import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './components/change-password/change-password.component';


import { LeftMenuAdminComponent } from './components/left-menu-admin/left-menu-admin.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';



const routes: Routes = [
  {
    path: '', component: TopBarComponent,
    children: [
     // { path: 'equipment-management', data: { roles: [Role.masterAdmin, Role.customerAdmin], accessLevel: 1 }, component: EquipmentManagementComponent },
     
    ]
  },
  {path: 'my-profile',component:MyProfileComponent},
 
  {
    path: '', component: LeftMenuAdminComponent,
    children: [

      // { path: 'unit-mine', data: { roles: [Role.masterAdmin, Role.customerAdmin], accessLevel: 1 }, component: UmUnitMineOverviewComponent },
     
      //{path:'operations-control',data: { roles: [Role.masterAdmin, Role.customerAdmin], accessLevel: 1 },component:OperationsControlComponent }

    ]
  },
  {path:'change-password',component:ChangePasswordComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainSharedRoutingModule { }
